import React from "react"
import { useImage, LoadingState } from "@/common/hooks/use_image"
import cn from "classnames"

interface AsyncImageProps {
  src: string
  onClick?: () => void
  loadingElement?: () => React.ReactElement
  errorElement?: () => React.ReactElement
  classes?: string
}

const AsyncImage: React.FC<AsyncImageProps> = props => {
  const [image, loadStatus] = useImage(props.src)

  if (loadStatus === LoadingState.Error) {
    return props.errorElement ? props.errorElement() : <React.Fragment />
  }

  if (!image) {
    return props.loadingElement ? props.loadingElement() : <React.Fragment />
  }

  return (
    <img
      src={props.src}
      onClick={props.onClick}
      loading="lazy"
      className={cn("data-hj-suppress m-auto h-auto max-h-full w-auto max-w-full", props.classes)}
    />
  )
}

export default AsyncImage
